export const PREPAID_EXPENSE_TYPE = 'isPrepaid';
export const PERIOD = 'period';
export const AFFILIATE = 'affiliate';
export const APPLICATION = 'application';
export const NETWORK = 'network';
export const CLUSTER = 'cluster';
export const PLATFORM = 'platform';
export const CAMPAIGNS = 'campaigns';
export const AMOUNT = 'amount';
export const CURRENCY = 'currency';
export const ADJUSTMENT_REASON = 'adjustmentReason';
export const TYPE = 'type';
export const COUNTRY = 'country';
export const STATS = 'stats';

export const TYPE_COST_ADJUSTMENT = 3;
export const TYPE_BY_REGS = 1;

export const DEPENDENCIES = {
  [APPLICATION]: [AFFILIATE],
  [NETWORK]: [APPLICATION],
  [PLATFORM]: [APPLICATION, NETWORK],
  [CAMPAIGNS]: [APPLICATION, NETWORK, AFFILIATE, CLUSTER, PLATFORM],
  [STATS]: [
    AFFILIATE,
    AMOUNT,
    APPLICATION,
    CAMPAIGNS,
    CLUSTER,
    COUNTRY,
    CURRENCY,
    NETWORK,
    PERIOD,
    PLATFORM,
    ADJUSTMENT_REASON,
  ],
  [TYPE]: [
    AFFILIATE,
    AMOUNT,
    APPLICATION,
    CAMPAIGNS,
    CLUSTER,
    COUNTRY,
    CURRENCY,
    NETWORK,
    PERIOD,
    PLATFORM,
  ],
};
